module.exports = __webpack_public_path__ + "img/info_banner5.20d395b.jpg";